// /////////////////////////////////////////////////////////////
// [ファイル] SfaProjectsListProvider.tsx
// [概要] /sfa/projects 配下 (一覧 / 新規登録 / 詳細) で一覧の状態を共有するための Context。
//        親 Layout (SfaProjectsLayout) で一度だけ useSfaProjectsV2 を呼び、一覧ページが参照する。
//        旧画面の SalesProjectsTableProvider と同じ作り。
// /////////////////////////////////////////////////////////////
import { createContext, useContext } from 'react';
import type { MutableRefObject } from 'react';
import type { useSfaProjectsV2 } from '../hooks/useSfaStructure';

export type SfaProjectsListContextValue = ReturnType<typeof useSfaProjectsV2> & {
  viewLevel: string;
  permissions: string[] | null;
  // 一覧テーブルのスクロール位置。Layout 側で ref として持ち、タブ内 (scrollStorageKey) にも保存する。
  // 詳細から戻る・HOME 経由・再読み込みのいずれでも同じ位置から表示する
  scrollPositionRef: MutableRefObject<number>;
  scrollStorageKey?: string;
  // 表示列（キーの並び。案件名が先頭）。利用者ごとにブラウザに残し、保存した条件から適用したときはその列になる
  columns: string[];
  setColumns: (cols: string[]) => void;
};

export const SfaProjectsListContext = createContext<SfaProjectsListContextValue | null>(null);

export const useSfaProjectsListContext = (): SfaProjectsListContextValue => {
  const ctx = useContext(SfaProjectsListContext);
  if (!ctx) {
    throw new Error('useSfaProjectsListContext must be used within <SfaProjectsLayout>');
  }
  return ctx;
};
